import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-247">
    <App data-id="element-248" />
  </React.StrictMode>);